import { Box, Text } from '@mantine/core';
import clsx from 'clsx';
import { Icon } from '@/components';
import { type DisplayStyleConfig, SuggestedModuleDisplayStyle } from '@/types';
import type { IconName } from '@/components/Icon';
import styles from './SuggestedModuleModal.module.sass';

type DisplayStyleOptionProps = {
  option: DisplayStyleConfig;
  isSelected: boolean;
  isDisabled: boolean;
  badge?: string;
  onClick: (value: SuggestedModuleDisplayStyle) => void;
};

export const DisplayStyleOption = ({ option, isSelected, isDisabled, badge, onClick }: DisplayStyleOptionProps) => {
  return (
    <Box
      className={clsx(styles.displayStyleCard, {
        [styles.selected]: isSelected,
        [styles.disabled]: isDisabled,
      })}
      onClick={() => !isDisabled && onClick(option.value)}
    >
      <Icon name={option.icon as IconName} size={24} className={styles.displayStyleIcon} />
      <Text className={styles.displayStyleTitle}>{option.label}</Text>
      <Text className={styles.displayStyleDescription}>{option.description}</Text>
      {badge && (
        <div
          className={clsx({
            [styles.requiredBadge]: badge === 'REQUIRED',
            [styles.recommendedBadge]: badge !== 'REQUIRED',
          })}
        >
          {badge}
        </div>
      )}
    </Box>
  );
};
